/**
 * Backend API paths shared by every RepVantage app. Product-only paths live in
 * the product. The archived CRM page routes and CRM-only API groups were
 * removed when this file moved out of apps/crm (2026-10-01).
 */

export const API = {
  AUTH: {
    GOOGLE: '/api/auth/google',
    CALLBACK: '/api/auth/google/callback',
    ME: '/api/auth/me',
    PROVIDERS: '/api/auth/providers',
    REGISTER: '/api/auth/register',
    LOGIN: '/api/auth/login',
    ADMIN_LOGIN: '/api/auth/admin/login',
    LOGOUT: '/api/auth/logout',
    REFRESH: '/api/auth/refresh',
    VERIFY_EMAIL: '/api/auth/verify-email',
    RESEND_VERIFICATION: '/api/auth/resend-verification',
    FORGOT_PASSWORD: '/api/auth/forgot-password',
    RESET_PASSWORD: '/api/auth/reset-password',
    // WorkOS
    WORKOS_STATUS: '/api/auth/workos/status',
    WORKOS_LOGIN: '/api/auth/workos/login',
    WORKOS_AUTH_URL: '/api/auth/workos/authorization-url',
    WORKOS_CALLBACK: '/api/auth/workos/callback',
    // MFA
    MFA_STATUS: '/api/auth/mfa/status',
    MFA_SETUP: '/api/auth/mfa/setup',
    MFA_ENABLE: '/api/auth/mfa/enable',
    MFA_DISABLE: '/api/auth/mfa/disable',
    MFA_VERIFY: '/api/auth/mfa/verify',
    MFA_RECOVERY_CODES: '/api/auth/mfa/recovery-codes',
    // Sessions
    SESSIONS: '/api/auth/sessions',
    SESSION_REVOKE: (sessionId: string) => `/api/auth/sessions/${sessionId}`,
    SESSIONS_REVOKE_ALL: '/api/auth/sessions/revoke-all',
    // Audit
    AUDIT_EVENTS: '/api/auth/audit/events',
    AUDIT_STATS: '/api/auth/audit/stats',
    AUDIT_MY_EVENTS: '/api/auth/audit/my-events',
    // Password
    PASSWORD_CHECK_STRENGTH: '/api/auth/password/check-strength',
    PASSWORD_CHANGE: '/api/auth/password/change',
  },

  USERS: {
    ABILITIES: '/api/users/me/abilities',
  },

  INTEGRATIONS: {
    LINKED: '/api/integrations/linked',
  },
} as const;

export type APIEndpoint = string;

/**
 * Helper to build full API URL from endpoint
 * In development, returns relative path to use Vite's proxy
 * In production, uses VITE_BACKEND_URL or VITE_API_URL env var
 */
export function apiUrl(endpoint: string): string {
  if (import.meta.env.VITE_USE_PROXY === 'true') {
    return endpoint;
  }
  const baseUrl = import.meta.env.VITE_API_URL || '';
  return `${baseUrl}${endpoint}`;
}
